<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().is_organization_admin">
  <h2>You do not have permission to manage membership categories.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().is_organization_admin && serverError === null">

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingReorder">
      Saving category order...
    </div>
  </div>

  <h2 class="d-inline-block">
    Membership Categories
    <span *ngIf="loadingResults" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingResults && resultList && resultList.results">({{ resultList.count.toLocaleString() }})</span>
  </h2>

  <div class="float-right mb-1">
    <a class="btn btn-outline-primary mr-2"
       [href]="orgConfig.getOrganizationConfig() ? orgConfig.getOrganizationConfig().climber_app_base_url + 'membership-catalog/' : '#'"
       target="_blank">
      View Catalog
    </a>
    <a class="btn btn-success" routerLink="/membership-settings/categories/add">
      Create New Category
    </a>
  </div>

  <div class="alert" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Name</th>
        <th scope="col"># Membership Types</th>
        <th></th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let category of resultList.results;  let catIdx = index">
        <td>{{ category.name }}</td>
        <td>{{ category.assigned_memberships.length }}</td>
        <td class="table-button-cell">
          <div class="float-right">
            <button class="btn btn-secondary btn-sm mr-1"
                    [disabled]="catIdx === 0"
                    [class.disabled]="catIdx === 0"
                    ngbTooltip="Move to top"
                    (click)="shiftCategory(category, true, true)">
              &uarr;&uarr;&uarr;
            </button>
            <button class="btn btn-secondary btn-sm mr-1"
                    [disabled]="catIdx === 0"
                    [class.disabled]="catIdx === 0"
                    ngbTooltip="Move up one"
                    (click)="shiftCategory(category, true, false)">
              &uarr;
            </button>
            <button class="btn btn-secondary btn-sm mr-1"
                    ngbTooltip="Move down one"
                    [disabled]="catIdx >= (resultList.results.length - 1)"
                    [class.disabled]="catIdx >= (resultList.results.length - 1)"
                    (click)="shiftCategory(category, false, false)">
              &darr;
            </button>
            <button class="btn btn-secondary btn-sm mr-2"
                    ngbTooltip="Move to bottom"
                    [disabled]="catIdx >= (resultList.results.length - 1)"
                    [class.disabled]="catIdx >= (resultList.results.length - 1)"
                    (click)="shiftCategory(category, false, true)">
              &darr;&darr;&darr;
            </button>
            <a class="btn btn-outline-primary btn-sm"
               routerLink="/membership-settings/categories/{{ category.id }}">
              Edit
            </a>
          </div>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingResults ? 'Loading...' : 'No categories' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

</div>
